// `YYYY-MM-DD` API serialisation (ported from legacy `formatDateForPost`,
// `composables/format.js` L661–668). Locale-independent; the exact output shape is
// depended on by 16 call-sites, so it is preserved byte-for-byte: zero-padded month
// and day from the **local** date parts, and a falsy input is returned unchanged.

/**
 * Serialise a `Date` to `YYYY-MM-DD` using local date parts. A falsy input
 * (`null` / `undefined`) is returned as-is, matching legacy behaviour.
 */
export function toApiDate(date: Date): string
export function toApiDate(date: null | undefined): null | undefined
export function toApiDate(date: Date | null | undefined): string | null | undefined {
  if (!date) return date
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  return `${year}-${month}-${day}`
}
